export default __webpack_public_path__ + "static/media/uy.f53324b6.svg";